import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ConfigDB from "../../../Config/ThemeConfig";
import { TotalEarnings, TotalInvestment, TotalUsers, TotalVisitors } from "../../../Constant";
import { radialChart, radialChart_1, sparklingOptions, WidgetCardChart, WidgetCardChart2 } from "../../../Data/DashBoard/Ecommerce/ChartistChart2";
import WidgetCaredSub from "./WidgetCaredSub";

const WidgetCard = () => {
  const primary = ConfigDB.color.primary_color;
  const secondary = ConfigDB.color.secondary_color;
  return (
    <>
      <Col xl="6" className=" chart_data_left">
        <Card>
          <CardBody className="p-0">
            <Row className="m-0 chart-main">
              <WidgetCaredSub type="bar" options={sparklingOptions} cardData={{ title: TotalEarnings, price: 85956.23 }} chartData={WidgetCardChart} badgeColor="primary" color="primary" />
              <WidgetCaredSub type="bar" options={sparklingOptions} cardData={{ title: TotalInvestment, price: 30250.5 }} chartData={WidgetCardChart2} badgeColor="secondary" color="secondary" />
            </Row>
          </CardBody>
        </Card>
      </Col>
      <Col xl="6" className="chart_data_right">
        <Card>
          <CardBody className="p-0">
            <Row className="m-0 chart-main">
              <WidgetCaredSub type="radial" cardData={{ title: TotalVisitors, price: 405984 }} chartData={radialChart} badgeColor="primary" color={primary} />
              <WidgetCaredSub type="radial" cardData={{ title: TotalUsers, price: 254562 }} chartData={radialChart_1} badgeColor="secondary" color={secondary} />
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default WidgetCard;
